export enum UnloadPenaltiesFilterEnum {
  IS_FILTERED_ORGANIZATION = 'isFilteredOrganization',
  PAYMENT_AMOUNT = 'paymentAmount',
  PAYMENT_ORG_INN = 'paymentOrgInn',
}
